import { render, staticRenderFns } from "./GoogleAuth.vue?vue&type=template&id=72284966&scoped=true"
import script from "./GoogleAuth.vue?vue&type=script&lang=js"
export * from "./GoogleAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72284966",
  null
  
)

export default component.exports